import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer-container">
        <div className="title">
          Thanh tra tỉnh Quảng Ngãi
        </div>
        <div className="address">
          Địa chỉ: Số 99 Hùng Vương - TP Quảng Ngãi - tỉnh Quảng Ngãi
        </div>
      </footer>
    );
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/layout/partials/Footer.jsx